import { service } from "."
import { jwtHeader } from "utils/jwtHeader"

export default {
  getAll: () => service.get("/patterns", jwtHeader()),
  getOne: (id) => service.get(`/patterns/${id}`, jwtHeader()),
}
